import { createFileRoute } from '@tanstack/react-router';
import { createCaslGuard } from '@/lib/auth/permissionGuards';

import { SettingsPage } from '@/pages/settings/SettingsPage';

export const Route = createFileRoute('/$slug/organization-settings/settings')({
  beforeLoad: createCaslGuard('OrgSettings'),
  component: SettingsPage
});
